import React from "react";
import { useNavigate } from "react-router-dom";

const StartExamButton = ({ data, styles }) => {
  const navigate = useNavigate();

  const handleStart = () => {
    navigate("/client/topics");
  };

  return (
    <div>
      <button
        type="button"
        onClick={handleStart}
        className={`${styles} rounded-md cursor-pointer px-6`}
      >
        {data}
      </button>
    </div>
  );
};

export default StartExamButton;
